/**
 * Brightness Style05 - Stitch v2：gold 主題、light_mode、灰→白滑桿、Dim/Brilliant
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import { resolveRangeFromAttributes } from './traitStyleConfig'
import './BrightnessStyle05.css'

export function BrightnessStyle05({
  trait,
  state,
  attributes,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const { min: MIN, max: MAX } = resolveRangeFromAttributes(attributes, trait, 'brightness')
  const raw = (state?.brightness as number) ?? Math.round((MIN + MAX) / 2)
  const currentBrightness = Math.max(MIN, Math.min(MAX, raw))
  const [brightness, setBrightness] = useState(currentBrightness)

  useEffect(() => {
    const v = Math.max(MIN, Math.min(MAX, (state?.brightness as number) ?? Math.round((MIN + MAX) / 2)))
    setBrightness(v)
  }, [state?.brightness, MIN, MAX])

  const handleChange = (value: number) => {
    const clamped = Math.max(MIN, Math.min(MAX, Math.round(value)))
    setBrightness(clamped)
    void onCommand('setBrightness', { brightness: clamped })
  }

  return (
    <div className="trait-brightness-style05 trait-stitch-v2-glass">
      <div className="trait-brightness-style05__header">
        <span className="trait-brightness-style05__title">Brightness</span>
        <span className="material-symbols-outlined trait-brightness-style05__icon">light_mode</span>
      </div>
      <input
        type="range"
        min={MIN}
        max={MAX}
        value={brightness}
        onChange={(e) => setBrightness(Number(e.target.value))}
        onMouseUp={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        onTouchEnd={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        className="trait-brightness-style05__slider"
        disabled={disabled}
      />
      <div className="trait-brightness-style05__labels">
        <span>Dim</span>
        <span>Brilliant</span>
      </div>
    </div>
  )
}
